module.exports = __webpack_public_path__ + "f2e8e38da1b724d35d59d345d6386b21.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/sp-header/sp-breadcrumbs/sp-breadcrumbs.html
// module id = 1013
// module chunks = 0